export const BULK_CONCURRENCY = 10;

const sleep = (ms: number) => new Promise(r => setTimeout(r, ms));

export const withRetry = async <T>(fn: () => Promise<T>, retries = 2) => {
    let attempt = 0, lastErr: any;
    while (attempt <= retries) {
        try { return await fn(); }
        catch (e: any) {
            const status = e?.response?.status;
            // ретраим только сетевые/временные (429/5xx)
            if (status !== 429 && (status < 500 || status > 599)) throw e;
            lastErr = e;
            await sleep(300 * Math.pow(2, attempt)); // backoff
            attempt++;
        }
    }
    throw lastErr;
};

export const promisePool = async <T>(
    items: T[],
    limit: number,
    worker: (item: T, index: number) => Promise<void>
) => {
    let i = 0;
    const runners = Array.from({ length: Math.min(limit, items.length) }, async () => {
        while (true) {
            const idx = i++;
            if (idx >= items.length) break;
            await worker(items[idx], idx);
        }
    });
    await Promise.all(runners);
};
